import router from '@/router';
import { defineStore } from 'pinia'
import { Ref, ref, nextTick } from "vue";
import Cache from "@/common/utils/cache";
export const useStore = defineStore('tags', () => {
  const tags: Ref<any[]> = ref([]);
  const tag: Ref<any> = ref('');

  // 获取唯一key
  const getKey = () => {
    return String(new Date().getTime()) + String((Math.random() * 1000).toFixed(0));
  }

  // 添加固定标签
  const addAffixTag = (e: any) => {
    if (!tags.value.some(x => x.name === e.name)) {
      e.key = getKey();
      tags.value.unshift(e);
      addCachedView(e);
    }
  }

  // 添加标签
  const addTag = (e: any) => {
    if (tags.value.findIndex(x => x.name === e.name) === -1) {
      e.key = getKey();
      tags.value.push(e);
      addCachedView(e);
    } else {
      e.key = tags.value.find(x => x.name === e.name).key;
      tags.value.splice(tags.value.findIndex(x => x.name === e.name), 1, e);
    }
  }

  // 简单移除标签,不执行跳转动作
  const removeTagSimple = (e: any) => {
    tags.value.splice(tags.value.findIndex(x => x.name === e.name), 1);
    delCachedView(e);
  }

  // 移除标签
  const removeTag = async (e: any, next?: string) => {
    removeTagSimple(e);
    if (next) {
      tag.value = next;
    } else {
      tag.value = tags.value[tags.value.length - 1].name;
    }
    router.push({
      name: tags.value.find(x => x.name === tag.value).name,
      query: tags.value.find(x => x.name === tag.value).query,
      params: tags.value.find(x => x.name === tag.value).params,
    });
  }

  // 标签切换
  const tagChange = (e: any) => {
    tag.value = e.name;
  }

  // 标签对应页面刷新
  const refresh = (e: any, done: () => any) => {
    delCachedView(e);
    let item = tags.value.find(x => x.name === e.name);
    let idx = tags.value.findIndex(x => x.name === e.name);
    tags.value.splice(idx, 1);
    nextTick(() => {
      item.key = getKey();
      tags.value.splice(idx, 0, item);
      addCachedView(e);
      setTimeout(() => {
        done()
      }, 500)
    })
  }


  const cachedViews: Ref<any[]> = ref([]);
  const addCachedView = (view) => {
    if (cachedViews.value.includes(view?.name)) return;
    if (view?.meta && !view?.meta?.noCache) {
      cachedViews.value.push(view?.name);
    }
  }
  const delCachedView = (view) => {
    const index = cachedViews.value.indexOf(view.name)
    index > -1 && cachedViews.value.splice(index, 1)
  }
  // 初始化
  const init = () => {
    tags.value = [];
    tag.value = "";
  }
  return {
    cachedViews,
    addCachedView,
    delCachedView,
    tags,
    tag,
    addAffixTag,
    addTag,
    removeTagSimple,
    removeTag,
    tagChange,
    refresh,
    init,
  }
}, {
  persist: {
    enabled: true,
    key: new Cache().defineKey('tags'),
    storage: sessionStorage,
  }
} as any)
